import React, {
  useEffect, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  Input,
  Button,
  Modal,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import IntlMessages from 'util/IntlMessages';
import InfoView from 'components/common/InfoView';
import {
  getPermissions,
  addPermission,
  deletePermission,
  updatePermission,
} from '../../redux/actions/Auth';
import PermissionForm from './PermissionForm';
import { permissionColumns } from '../../components/common/Columns';
import Can from '../../util/can';
import { PERMISSIONS } from '../../constants/resources';
import generateQuery, { handleSearch as search } from '../../util/table';
import useForm from '../../hooks/useForm';

const Permissions = () => {
  const dispatch = useDispatch();
  const {
    addingPermission,
    data,
    loading,
    totalItems,
    pageSize,
    currentPage: current,
  } = useSelector(({ auth }) => auth.permissions);
  const [searchParams, setSearchParams] = useState('');
  const {
    form,
    onFormOk,
    formVisibility,
    handleShowModal,
    handleCancel,
    handleEditRecord,
    editableRecord,
  } = useForm();

  useEffect(() => {
    const pagination = `page=${current}&limit=${pageSize}`;
    dispatch(getPermissions(pagination));
  }, [dispatch]);

  const handleDeletePermission = (id) => {
    dispatch(deletePermission(id));
  };

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(getPermissions(generateQuery(pagination, filters, sorter, searchParams)));
  };

  const handleSearch = (searchValue) => {
    const query = search(
      searchValue.trim().replace(/([^a-zA-Z0-9])/g, '\\$1'),
      dispatch, getPermissions, permissionColumns,
    );
    setSearchParams(query);
  };

  const props = {
    loading,
    pagination: {
      current,
      pageSize,
      total: totalItems,
      showSizeChanger: false,
    },
    scroll: 'y',
    rowKey: '_id',
    columns: permissionColumns(handleDeletePermission, handleEditRecord),
    sticky: true,
    dataSource: data,
    onChange: handleOnChange,
  };

  const handleOk = (values) => {
    if (editableRecord._id) {
      dispatch(updatePermission(editableRecord._id, values));
    } else {
      dispatch(addPermission(values));
    }
  };

  return (
    (
      <div>
        <h2 className="title gx-mb-4"><IntlMessages id="permissions.title" /></h2>
        <Can I="create" a={PERMISSIONS}>
          <Button
            icon={<PlusOutlined />}
            type="primary"
            data-testid="add-permission-btn"
            onClick={() => handleShowModal()}
          >
            Add Permission
          </Button>

        </Can>
        <div className="justify-content-center">
          <Input.Search
            data-testid="search-input"
            placeholder="Search permissions"
            enterButton
            allowClear
            onSearch={handleSearch}
          />
          <Table data-testid="permissions-table" className="gx-table-responsive" {...props} />
        </div>
        <Modal
          title={editableRecord._id ? 'Edit Permission' : 'Add permission'}
          open={formVisibility}
          okText={editableRecord._id ? 'Save' : 'Add'}
          onOk={() => onFormOk(handleOk)}
          confirmLoading={addingPermission}
          onCancel={handleCancel}
        >
          <PermissionForm {...{ form }} />
        </Modal>
        <InfoView />
      </div>
    )
  );
};

export default Permissions;
